import PlaceholderPage from '@/components/PlaceholderPage';

export default function AdminConfiguracoes() {
  return <PlaceholderPage title="Configurações" description="Ajustes gerais do Portal do Colaborador." />;
}